/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {OfferVariable} from "./offerVariable.zod";

export const OfferRichTextContent = zod
  .object({
    richText: zod.string(),
    variables: zod.array(OfferVariable),
  })
  .describe("Frontend renders opaque rich text safely.");

export type OfferRichTextContent = zod.input<typeof OfferRichTextContent>;
export type OfferRichTextContentOutput = zod.output<typeof OfferRichTextContent>;
